<app-full-page-message
  *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
  *ngIf="!businessId || businessId.length <5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
  <div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.sales_report && source">
    <app-business-deductive *ngIf="businessId != '' && businessId != '0'" [currentBusinessId]="businessId"
      [businesses]="localService.loggedMember.businesses"></app-business-deductive>
    <span style="display:none;">
      <i class="material-icons on_language_changed" style="float:left;"
        (click)="onLanguageChanged()">replay_circle_filled</i>
    </span>
    <div *ngIf="isCompactSalesReport && source && source.content && source.content.items" class="center"
      style="max-width: 900px;">
      <div class="compact_header">
        <div class="banner">
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-6" style="text-align: right;">
                  <label>{{localService.languageContent.sales_report.sales_report_by}}&nbsp;:&nbsp;</label>
                </div>
                <div class="col-6">
                  <ngx-select [(ngModel)]="selectedReportBy" [optionValueField]="'key'" [optionTextField]="'value'"
                    [items]="source.reportBy" (select)="onSelectSalesReportBy()" [noAutoComplete]="true"
                    [placeholder]="localService.languageContent.sales_report.sales_report_by">
                  </ngx-select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-6" style="text-align: right;">
                  <label>{{localService.languageContent.sales_report.grand_total}}&nbsp;:&nbsp;</label>
                </div>
                <div class="col-6">
                  <span class="en" *ngIf="totalAmount">{{totalAmount | number: '1.2-2'}}&nbsp;</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="compact_body">
        <div class="banner compact_body_content">
          <div *ngIf="source.content.items.length == 0" style="text-align: center;">
            {{localService.languageContent.paging.no_records}}
          </div>
          <div *ngIf="source.content.items.length > 0">
            <div *ngIf="selectedReportBy == SalesReportBy.Receipt.toString()">
              <ng-container *ngFor="let item of source.content.items;index as idx">
                <div class="row styled_row">
                  <div class="col-md-6">
                    <span class="en dim">{{source.content.paging.currentPage == 1 && idx < 9 ? '0' : ''
                        }}{{((source.content.paging.currentPage - 1) * source.content.paging.dataPerPage) + (idx +
                        1)}}.&nbsp;</span>
                        <span class="en">{{item.v1 | localDate}}</span>
                  </div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-7" title="{{item.v12 && item.v12.length > 0 ? item.v12 : item.v16}}">
                        <span class="en button" (click)="onRoute(item.key)">{{item.v2}}&nbsp;</span>
                        <span [ngClass]="item.v12 && item.v12.length > 0 ? 'en' : ''">{{item.v12 && item.v12.length > 0
                          ? item.v12 : item.v16}}</span>
                      </div>
                      <div class="col-5" style="text-align: right;">
                        <span class="en"
                          ngbTooltip="{{item.v3 + ' - ' + (item.v8 && item.v8 != '' ? item.v8 : '0') + ' + ' + item.v7 + ' = ' + item.v5}}">{{item.v5
                          |
                          number:
                          '1.2-2'}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="row">
                <div class="col-12">
                  &nbsp;
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  &nbsp;
                </div>
              </div>
            </div>
            <div *ngIf="selectedReportBy != SalesReportBy.Receipt.toString()">
              <ng-container *ngFor="let item of source.content.items;index as idx">
                <div class="row styled_row">
                  <div class="col-8">
                    <span class="en dim">{{source.content.paging.currentPage == 1 && idx < 9 ? '0' : ''
                        }}{{((source.content.paging.currentPage - 1) * source.content.paging.dataPerPage) + (idx +
                        1)}}.</span>
                        <span
                          [ngClass]="selectedReportBy == SalesReportBy.Product.toString() ? localService.getLanguageCode(item.v7) : 'en'">{{item.v8}}</span>
                        <span class="en">&nbsp;({{item.v6}})</span>
                  </div>
                  <div class="col-4" style="text-align: right;">
                    <span class="en">{{item.v9 | number: '1.2-2'}}</span>
                  </div>
                </div>
              </ng-container>
              <div class="row">
                <div class="col-12">
                  &nbsp;
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="compact_footer">
        <div class="banner center" style="width: calc(100% - 45px); max-width: 900px;">
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-6">
                  <div class="wrap-div">
                    <button class="button_icon button_icon_color " style="top:5px;"
                      [disabled]="source.content.paging.currentPage <= 1"
                      (click)="onPagingRefresh(1)">arrow_circle_left</button>
                    &nbsp;
                    <button class="btn btn-primary" style="width:45px;" (click)="onLoad()">
                      <i class="material-icons icon_compact">refresh</i>
                    </button>
                    &nbsp;
                    <button class="button_icon button_icon_color " style="top:5px;"
                      [disabled]="source.content.paging.currentPage == source.content.paging.totalPage"
                      (click)="onPagingRefresh(2)">arrow_circle_right</button>
                  </div>
                </div>
                <div class="col-6" style="text-align: left;">
                  <app-date-picker [isTop]="true" [selectedDate]="source.content.paging.dateFromS"
                    (selectedDateChange)="source.content.paging.dateFromS = $event;"></app-date-picker>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-6">
                  <div class="wrap-div">
                    <button class="btn btn-primary" style="width:100%;margin-top:5px" (click)="onPrint()"
                      [disabled]="source.content.items.length == 0">
                      <i class="material-icons icon_compact">print</i>
                      <span>{{localService.languageContent.sales_report.print}}</span>
                    </button>
                  </div>
                </div>
                <div class="col-6" style="text-align: left;">
                  <app-date-picker [isTop]="true" [selectedDate]="source.content.paging.dateToS"
                    (selectedDateChange)="source.content.paging.dateToS = $event;"></app-date-picker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isCompactSalesReport" style="max-width:1400px;" class="banner center">
      <div class="row freeze_col freeze_height" style="margin-bottom: 10px;">
        <div class="col-md-3">
          <label>{{localService.languageContent.sales_report.report_time}}&nbsp;:&nbsp;</label>
          <span class="en">{{reportTime | date : 'hh:mm:ss a, dd-MMM-yyyy'}}</span>
        </div>
        <div class="col-md-3">
          <div class="row">
            <div class="col-6" style="text-align: right;">
              <label>{{localService.languageContent.sales_report.sales_report_by}}&nbsp;:&nbsp;</label>
            </div>
            <div class="col-6" [id]="elementIds.report_type_div">
              <div style="position: absolute;" [ngStyle]="{'width': (reportTypeWidth - 25) +'px'}">
                <ngx-select [(ngModel)]="selectedReportBy" [optionValueField]="'key'" [optionTextField]="'value'"
                  [items]="source.reportBy" (select)="onSelectSalesReportBy()" [noAutoComplete]="true"
                  [placeholder]="localService.languageContent.sales_report.sales_report_by">
                </ngx-select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row" *ngIf="selectedReportBy != SalesReportBy.Receipt.toString()">
            <div class="col-12">
              <input autocomplete="off" type="text" [(ngModel)]="searchKey" style="width:calc(100% - 40px)"
                [ngClass]="searchKey && selectedReportBy != SalesReportBy.Product.toString() ? 'en' : ''"
                [disabled]="selectedReportBy == SalesReportBy.Receipt.toString()"
                title="{{localService.languageContent.common.search}}" id="{{elementIds.txt_search_key}}"
                placeholder="{{localService.languageContent.common.search}}" (keydown.enter)="onLoad()" />
              <button class="button_icon button_icon_color icon_adjust_header" style="top:10px"
                [disabled]="selectedReportBy == SalesReportBy.Receipt.toString()" (click)="onLoad()">search</button>
            </div>
          </div>
          <div class="row" *ngIf="selectedReportBy == SalesReportBy.Receipt.toString()">
            <div class="col-6" style="text-align: right;">
              <label>{{localService.languageContent.sales_report.payment_mode}}&nbsp;:&nbsp;</label>
            </div>
            <div class="col-6" [id]="elementIds.payment_type_div">
              <div style="position: absolute;" [ngStyle]="{'width': (reportTypeWidth - 25) +'px'}">
                <ngx-select [(ngModel)]="selectedPaymentBy" [optionValueField]="'key'" [optionTextField]="'value'"
                  [items]="source.paymentBy" (select)="onSelectSalesReportBy()" [noAutoComplete]="true"
                  [allowClear]="true" (remove)="onRemovePaymentBy()"
                  [placeholder]="localService.languageContent.sales_report.payment_mode">
                </ngx-select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <app-business-relationship [businessId]="businessId" (onUserUpdated)="onUserUpdated($event)"
            [relationShipType]="relationShipType" [relationShipRole]="relationShipRole"></app-business-relationship>
        </div>
      </div>
      <div class="row freeze_col freeze_height" style="margin-bottom: 10px;">
        <div class="col-3"
          title="{{localService.languageContent.sales_report.report_time}}&nbsp;:&nbsp;{{reportTime | date : 'hh:mm:ss a, dd-MMM-yyyy'}}">
          <label>{{localService.languageContent.sales_report.report_range}}&nbsp;:&nbsp;</label>
          <span class="en">{{reportRange}}</span>
        </div>
        <div class="col-3">
          <label>{{localService.languageContent.sales_report.grand_total}}&nbsp;:&nbsp;</label>
          <span class="en" *ngIf="totalAmount">{{totalAmount | number: '1.2-2'}}&nbsp;</span>
          <span class="en" *ngIf="!totalAmount">-&nbsp;</span>
        </div>
        <div class="col-3">
          <label>{{
            selectedReportBy == SalesReportBy.Receipt.toString() ?
            localService.languageContent.sales_report.paid_amount
            :localService.languageContent.sales_report.total_price}}&nbsp;:&nbsp;</label>
          <span class="en">{{(selectedReportBy == SalesReportBy.Receipt.toString() ? totalPaidAmount :totalPrice)|
            number: '1.2-2'}}&nbsp;</span>
        </div>
        <div class="col-3">
          <label>{{
            selectedReportBy == SalesReportBy.Receipt.toString() ?
            localService.languageContent.sales_report.remaining_amount
            :localService.languageContent.sales_report.total_price_tax}}&nbsp;:&nbsp;</label>
          <span class="en">{{(selectedReportBy == SalesReportBy.Receipt.toString() ? totalRemainingAmount
            :totalPriceWithTax)| number: '1.2-2'}}&nbsp;</span>
        </div>
      </div>
      <div class="row freeze_col freeze_height"
        *ngIf="isBusinessHasPurchaseEntry || (source.productLabels && source.productLabels.length > 1)">
        <div class="col-4" *ngIf="source.productLabels && source.productLabels.length > 1">
          <div class="row">
            <div class="col-4">
              <label>{{localService.languageContent.sales_report.product_label}}&nbsp;:&nbsp;</label>
            </div>
            <div class="col-8">
              <div style="position: absolute;" [ngStyle]="{'width': (reportTypeWidth - 25) +'px'}">
                <ngx-select [(ngModel)]="selectedProductLabel" [optionValueField]="'key'" [optionTextField]="'value'"
                  [allowClear]="true" [items]="source.productLabels" (select)="onLoad()" [noAutoComplete]="true"
                  (remove)="onLoad()" [placeholder]="localService.languageContent.sales_report.product_label">
                </ngx-select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4" *ngIf="isBusinessHasPurchaseEntry">
          <label>{{localService.languageContent.sales_report.purchased_amount}}&nbsp;:&nbsp;</label>
          <span class="en">{{totalPurchasePriceWithTax | number: '1.2-2'}}&nbsp;</span>
        </div>
        <div class="col-4" *ngIf="isBusinessHasPurchaseEntry">
          <label>{{localService.languageContent.sales_report.profit}}&nbsp;:&nbsp;</label>
          <span class="en" [ngStyle]="{'color' : profit >= 0 ? 'green' : 'red' }">{{profit | number:
            '1.2-2'}}&nbsp;</span>
        </div>
      </div>
      <div *ngIf="selectedReportBy == SalesReportBy.Receipt.toString() && source.content && source.content.items">
        <div class="row row_header freeze_col freeze_height">
          <div class="col-md-4">
            <div class="row">
              <div class="col-7">
                <span>{{localService.languageContent.sales_report.paid_on}}</span>
              </div>
              <div class="col-5">
                <label *ngIf="isExcludedEnabled" style="font-weight: normal; margin-left: 15px;"
                  title="{{localService.languageContent.common.is_excluded}}">
                  <input type="checkbox" [(ngModel)]="isExcluded" (change)="onLoad()" />
                  <span class="normal_color">&nbsp;</span>
                </label>
                <span>{{localService.languageContent.sales_report.token_num}}</span>
              </div>
            </div>
          </div>
          <div [ngClass]="isBusinessHasPurchaseEntry ? 'col-md-5' : 'col-md-8'">
            <div class="row">
              <div class="col-3">
                <span>{{localService.languageContent.sales_report.grand_total}}</span>
              </div>
              <div class="col-3">
                <span>{{localService.languageContent.sales_report.paid_amount}}</span>
              </div>
              <div class="col-3">
                <span>{{localService.languageContent.sales_report.remaining_amount}}</span>
              </div>
              <div class="col-3">
                <span>{{localService.languageContent.sales_report.payment_mode}}</span>
              </div>
            </div>
          </div>
          <div *ngIf="isBusinessHasPurchaseEntry" class="col-md-3">
            <div class="row">
              <div class="col-6">
                <span>{{localService.languageContent.sales_report.purchased_amount}}</span>
              </div>
              <div class="col-6">
                <span>{{localService.languageContent.sales_report.profit}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
          <div class="row styled_row freeze_col" *ngFor="let item of source.content.items;index as idx">
            <div class="col-md-4">
              <div class="row">
                <div class="col-5">
                  <span class="en dim">{{source.content.paging.currentPage == 1 && idx < 9 ? '0' : ''
                      }}{{((source.content.paging.currentPage - 1) * source.content.paging.dataPerPage) + (idx +
                      1)}}.</span>
                      <span class="en">{{item.v1 | localDate}}</span>
                </div>
                <div class="col-7" title="{{item.v12 && item.v12.length > 0 ? item.v12 : item.v16}}">
                  <span class="en button" (click)="onRoute(item.v14)">{{item.v2}}</span>
                  <span [ngClass]="item.v12 && item.v12.length > 0 ? 'en' : ''">&nbsp;{{item.v12 && item.v12.length > 0
                    ? item.v12 : item.v16}}</span>
                </div>
              </div>
            </div>
            <div [ngClass]="isBusinessHasPurchaseEntry ? 'col-md-5' : 'col-md-8'">
              <div class="row">
                <div class="col-3" style="text-align: right;">
                  <span class="en"
                    ngbTooltip="{{item.v3 + ' - ' + (item.v8 && item.v8 != '' ? item.v8 : '0') + ' + ' + item.v7 + ' = ' + item.v5}}">{{item.v5
                    |
                    number:
                    '1.2-2'}}</span>
                </div>
                <div class="col-3" style="text-align: right;">
                  <span class="en" ngbTooltip="{{item.v11}}">{{item.v11 | number:
                    '1.2-2'}}</span>
                </div>
                <div class="col-3" style="text-align: right;">
                  <button class=" button_link link_btn" (click)="onAction(2,item.key)" style="padding: 0px;"
                    *ngIf="item.v15 == '0' && item.v13.toString() != '0'">
                    <span class="en">
                      {{item.v13 | number: '1.2-2'}}
                    </span>
                  </button>
                  <span class="en" ngbTooltip="{{item.v13}}" *ngIf="!(item.v15 == '0' && item.v13.toString() != '0')">
                    {{item.v13 | number: '1.2-2'}}
                  </span>
                </div>
                <div class="col-3">
                  <button class=" button_link link_btn" (click)="onAction(1,item.key)" style="padding: 0px;"
                    *ngIf="item.v4 == PaymentType.MultiPayment.toString()">
                    <span>{{localService.getText(source.options,item.v4)}}</span>
                  </button>
                  <span
                    *ngIf="item.v4 != PaymentType.MultiPayment.toString()">{{localService.getText(source.options,item.v4)}}</span>
                </div>
              </div>
            </div>
            <div *ngIf="isBusinessHasPurchaseEntry" class="col-md-3">
              <div class="row">
                <div class="col-6" style="text-align: right;">
                  <span class="en">{{item.v9 | number: '1.2-2'}}</span>
                </div>
                <div class="col-6" style="text-align: right;">
                  <span class="en" [ngStyle]="{'color' : item.v10 >= 0 ? 'green' : 'red' }">{{item.v10 | number:
                    '1.2-2'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="selectedReportBy != SalesReportBy.Receipt.toString() && source.content && source.content.items">
        <div class="row row_header freeze_col freeze_height">
          <div class="row">
            <div class="col-md-4">
              <div class="row">
                <div class="col-12">
                  <span id="{{elementIds.lbl_title}}">{{localService.getText(source.reportBy,selectedReportBy)}}</span>
                </div>
              </div>
            </div>
            <div [ngClass]="isBusinessHasPurchaseEntry ? 'col-md-5' : 'col-md-8'">
              <div class="row">
                <div class="col-3">
                  <span>{{localService.languageContent.sales_report.qty}}</span>
                </div>
                <div class="col-4">
                  <span>{{localService.languageContent.sales_report.total_price}}</span>
                </div>
                <div class="col-5">
                  <span>{{localService.languageContent.sales_report.total_price_tax}}</span>
                </div>
              </div>
            </div>
            <div *ngIf="isBusinessHasPurchaseEntry" class="col-md-3">
              <div class="row">
                <div class="col-6">
                  <span>{{localService.languageContent.sales_report.purchased_amount}}</span>
                </div>
                <div class="col-6">
                  <span>{{localService.languageContent.sales_report.profit}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
          <div class="row styled_row freeze_col" *ngFor="let item of source.content.items;index as idx">
            <div class="col-md-4">
              <div class="row">
                <div class="col-12">
                  <span class="en dim">{{source.content.paging.currentPage == 1 && idx < 9 ? '0' : ''
                      }}{{((source.content.paging.currentPage - 1) * source.content.paging.dataPerPage) + (idx +
                      1)}}.</span>
                      <span
                        [ngClass]="selectedReportBy == SalesReportBy.Product.toString() ? localService.getLanguageCode(item.v7) : 'en'">{{item.v8}}</span>
                </div>
              </div>
            </div>
            <div [ngClass]="isBusinessHasPurchaseEntry ? 'col-md-5' : 'col-md-8'">
              <div class="row">
                <div class="col-3" style="text-align: right;" title="{{item.v6}}">
                  <span class="en">{{item.v6}}</span>
                </div>
                <div class="col-4" style="text-align: right;" title="{{item.v5 | number: '1.2-2'}}">
                  <span class="en">{{item.v5 | number: '1.2-2'}}</span>
                </div>
                <div class="col-5" style="text-align: right;" title="{{item.v9 | number: '1.2-2'}}">
                  <span class="en">{{item.v9 | number: '1.2-2'}}</span>
                </div>
              </div>
            </div>
            <div *ngIf="isBusinessHasPurchaseEntry" class="col-md-3">
              <div class="row">
                <div class="col-6" style="text-align: right;">
                  <span class="en">{{item.v10 | number: '1.2-2'}}</span>
                </div>
                <div class="col-6" style="text-align: right;">
                  <span class="en" [ngStyle]="{'color' : item.v11 >= 0 ? 'green' : 'red' }">{{item.v11 | number:
                    '1.2-2'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-paging *ngIf="!isCompactSalesReport && source && source.content" [paging]="source.content.paging"
      (onPagingRefreshed)="onLoad()" (onPagingPrint)="onPrint()" (onDownloadExcel)="onDownload()"
      (onShowGraph)="onShowGraph()" [graphValue1]="businessId"></app-paging>
    <app-print *ngIf="IsPrint" [fileName]="fileName" [isFontPathCss]="true" [content]="printContent"
      (onPrinted)="onPrinted()"></app-print>
  </div>
</div>
<div>
  <app-bill-payment-types *ngIf="isOpenPaymentModes" [(isOpenPopup)]="isOpenPaymentModes"
    [paymentMethods]="source.paymentBy" [billAmount]="selectedTotalAmount" [businessId]="businessId"
    [selectedPaymentMode]="selectedPaymentMode" [receiptId]="selectedBillId" [isPaid]="isAmountPaid" (onPaid)="onLoad()"
    [isShowPayAndPrint]="false" [isShowPayAndSendToPhone]="false" [isRemainingPayment]="true" />
</div>
<span style="display: none;">
  <button class="after_device_settings_loaded" (click)="onCheckDeviceSettings()">After Device Settings</button>
  <button class="after_access_check" (click)="onLoad(true)">After Access Check</button>
</span>